// Templates.js
import React, { useState, useEffect } from 'react';
import { templatesApi } from '../api/client';
import { Badge, Modal, Spin, useFlash, F } from '../components/UI';
import { Trash, Send } from '../components/Icons';
import { useAuth } from '../context/AuthContext';

const TYPES = ['Enquiry','Follow-up','Service','Promotional'];

export default function Templates() {
  const { canDelete, canWrite } = useAuth();
  const [rows, setRows] = useState([]); const [busy, setBusy] = useState(true);
  const [showAdd, setAdd] = useState(false); const { show, Flash } = useFlash();
  const [form, setForm] = useState({ name:'',type:'Enquiry',body:'' });
  const set = k => e => setForm(f=>({...f,[k]:e.target.value}));

  const [editRow, setEditRow] = useState(null);
  const [editForm, setEditForm] = useState({ name:'',type:'Enquiry',body:'' });
  const setE = k => e => setEditForm(f=>({...f,[k]:e.target.value}));

  useEffect(()=>{ templatesApi.list().then(({data})=>setRows(data)).finally(()=>setBusy(false)); },[]);

  const save = async () => {
    if(!form.name||!form.body) { show('Name and body required.','error'); return; }
    try { const {data}=await templatesApi.create(form); setRows(r=>[...r,data]); show('Template saved!'); setAdd(false); setForm({name:'',type:'Enquiry',body:''}); }
    catch { show('Failed.','error'); }
  };

  const openEdit = t => { setEditRow(t); setEditForm({ name:t.name, type:t.type, body:t.body }); };

  const saveEdit = async () => {
    if(!editForm.name||!editForm.body) { show('Name and body required.','error'); return; }
    try {
      const {data} = await templatesApi.update(editRow.id, editForm);
      setRows(r=>r.map(x=>x.id===editRow.id ? data : x));
      show('Template updated!'); setEditRow(null);
    } catch { show('Failed to update.','error'); }
  };

  const del = async id => { try { await templatesApi.delete(id); setRows(r=>r.filter(x=>x.id!==id)); show('Deleted.'); } catch { show('Failed.','error'); } };

  if (busy) return <Spin/>;
  return (
    <div>
      <Flash/>
      <div className="page-hd"><h2>Message Templates</h2>{canWrite&&<button className="btn btn-primary" onClick={()=>setAdd(true)}>+ Add Template</button>}</div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
        {rows.map(t=>(
          <div key={t.id} className="card" style={{marginBottom:0}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:8}}>
              <span style={{fontWeight:600,fontSize:13}}>{t.name}</span>
              <Badge label={t.type} cls="b-info"/>
            </div>
            <pre style={{fontSize:11.5,color:'var(--text2)',whiteSpace:'pre-wrap',fontFamily:'inherit',lineHeight:1.5,marginBottom:12}}>{t.body}</pre>
            <div style={{display:'flex',gap:6}}>
              <button className="btn btn-sm"><Send s={13}/> Use</button>
              {canWrite&&<button className="btn btn-sm" onClick={()=>openEdit(t)}>Edit</button>}
              {canDelete&&<button className="btn btn-sm btn-danger" onClick={()=>del(t.id)} title="Delete"><Trash s={13}/></button>}
            </div>
          </div>
        ))}
      </div>

      {/* Add Template Modal */}
      <Modal open={showAdd} onClose={()=>setAdd(false)} title="Add Template"
        footer={<><button className="btn" onClick={()=>setAdd(false)}>Cancel</button><button className="btn btn-primary" onClick={save}>Save Template</button></>}
      >
        <div className="fg-2">
          <F label="Template Name" req><input value={form.name} onChange={set('name')}/></F>
          <F label="Type"><select value={form.type} onChange={set('type')}>{TYPES.map(t=><option key={t}>{t}</option>)}</select></F>
          <F label="Message Body" req full><textarea style={{minHeight:160}} value={form.body} onChange={set('body')} placeholder="Use [Customer Name], [Product] as placeholders…"/></F>
        </div>
      </Modal>

      {/* Edit Template Modal */}
      <Modal open={!!editRow} onClose={()=>setEditRow(null)} title="Edit Template"
        footer={<><button className="btn" onClick={()=>setEditRow(null)}>Cancel</button><button className="btn btn-primary" onClick={saveEdit}>Save Changes</button></>}
      >
        <div className="fg-2">
          <F label="Template Name" req><input value={editForm.name} onChange={setE('name')}/></F>
          <F label="Type"><select value={editForm.type} onChange={setE('type')}>{TYPES.map(t=><option key={t}>{t}</option>)}</select></F>
          <F label="Message Body" req full><textarea style={{minHeight:160}} value={editForm.body} onChange={setE('body')} placeholder="Use [Customer Name], [Product] as placeholders…"/></F>
        </div>
      </Modal>
    </div>
  );
}
